<template>
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner" id="style-15">
      <vue-custom-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-x="scrollHanle"
      >
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <router-link
              v-if="
                enableAttendanceModule &&
                (isManager() ||
                  isNextManager() ||
                  hasCarparkClaimDelegation() ||
                  hasTimesheetDelegation()) &&
                hasAccess('', 'Dashboard') &&
                !hasOnlyLamrAccess()
              "
              :to="{ name: 'dashboard' }"
              tag="li"
              :class="$route.path.includes('/dashboard') ? activeClass : ''"
            >
              <a><i class="la la-dashboard"></i><span>Dashboard</span></a>
            </router-link>

            <li
              class="menu-title"
              v-if="
                enableInsuranceModule &&
                ((hasAccess('Benefit', null) && hasAccess('Insurance', null)) ||
                  role == 'admin') && !hasOnlyLamrAccess()
              "
            >
              <span>Insurance &amp; Benefit</span>
            </li>
            <li
              class="menu-title"
              v-if="
                role == 'employee' &&
                hasAccess('Benefit', null) &&
                !hasAccess('Insurance', null) &&
                !hasOnlyLamrAccess()
              "
            >
              <span>Benefit</span>
            </li>

            <!-- BENEFIT -->
            <li
              class="submenu"
              v-if="enableInsuranceModule && hasAccess('Benefit', null) && !hasOnlyLamrAccess()"
            >
              <a class="" v-if="hasAccess('Benefit', null)">
                <i class="la la-suitcase"></i>
                <span> Benefit</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <template v-if="role == 'admin'">
                  <router-link
                    :to="{ name: 'group' }"
                    tag="li"
                    :class="$route.path.includes('/group') ? activeClass : ''"
                  >
                    <a><i class="la la-tags"></i><span>Group</span></a>
                  </router-link>
                  <router-link
                    :to="{ name: 'benefitOption' }"
                    tag="li"
                    :class="$route.path == '/benefitoption' ? activeClass : ''"
                  >
                    <a>
                      <i class="la la-sitemap"></i>
                      <span>Benefit Option</span>
                    </a>
                  </router-link>
                  <router-link
                    :to="{ name: 'benefitItem' }"
                    tag="li"
                    :class="
                      $route.path.includes('/benefititem') ? activeClass : ''
                    "
                  >
                    <a><i class="la la-cog"></i> <span>Benefit Item</span></a>
                  </router-link>
                  <router-link
                    :to="{ name: 'benefitOptionItemMapping' }"
                    tag="li"
                    :class="
                      $route.path.includes('benefitoptionitemmapping')
                        ? activeClass
                        : ''
                    "
                  >
                    <a>
                      <i class="la la-dollar"></i>
                      <span> Benefit Option + <br />Benefit Item Mapping</span>
                    </a>
                  </router-link>
                </template>
                <router-link
                  :to="{ name: 'employeeBenefitOptionList' }"
                  tag="li"
                  :class="
                    $route.path.includes('employeebenefitoption')
                      ? activeClass
                      : ''
                  "
                  v-if="hasAccess('Benefit', 'My Benefit Options')"
                >
                  <a>
                    <i class="la la-money"></i>
                    <span v-if="role == 'admin'">
                      Employees' Benefit Options
                    </span>
                    <span v-else>My Benefit Options</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'benefitReport' }"
                  tag="li"
                  :class="
                    $route.path.includes('/benefitreport') ? activeClass : ''
                  "
                >
                  <a><i class="la la-file-text"></i> <span>Reports</span></a>
                </router-link>
              </ul>
            </li>

            <!-- INSURANCE -->
            <li
              class="submenu"
              v-if="
                enableInsuranceModule &&
                (hasAccess('Insurance', null) || role == 'admin') &&
                !hasOnlyLamrAccess()
              "
            >
              <a class="" v-if="hasAccess('Insurance', null)">
                <i class="la la-plus-circle"></i>
                <span>Insurance</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <template v-if="role == 'admin'">
                  <router-link
                    v-if="enableEnhancedInsuranceDependentModule"
                    :to="{ name: 'identityTypeMapping' }"
                    tag="li"
                    :class="
                      $route.path.includes('/identitytypemapping') ? activeClass : ''
                    "
                  >
                    <a>
                      <i class="fa fa-cog"></i>
                      <span>Identity Type Mapping</span>
                    </a>
                  </router-link>
                  <router-link
                    v-if="enableEnhancedInsuranceDependentModule"
                    :to="{ name: 'manageDependentAge' }"
                    tag="li"
                    :class="
                      $route.path.includes('/managedependentage') ? activeClass : ''
                    "
                  >
                    <a>
                      <i class="fa fa-cog"></i>
                      <span>Manage Dependent's Age</span>
                    </a>
                  </router-link>
                  <router-link
                    :to="{ name: 'insuranceType' }"
                    tag="li"
                    :class="
                      $route.path.includes('/insurancetype') ? activeClass : ''
                    "
                  >
                    <a>
                      <i class="la la-medkit"></i>
                      <span>Type of Insurance</span>
                    </a>
                  </router-link>
                  <router-link
                    :to="{ name: 'enrolmentCategory' }"
                    tag="li"
                    :class="
                      $route.path.includes('/enrolmentcategory')
                        ? activeClass
                        : ''
                    "
                  >
                    <a>
                      <i class="la la-users"></i>
                      <span>Enrolment Category</span>
                    </a>
                  </router-link>
                  <router-link
                    :to="{ name: 'insuranceCategoryMapping' }"
                    tag="li"
                    :class="
                      $route.path.includes('/insurancecategorymapping')
                        ? activeClass
                        : ''
                    "
                  >
                    <a>
                      <i class="la la-chain"></i>
                      <span>
                        Type of Insurance + <br />
                        Enrolment Category Mapping
                      </span>
                    </a>
                  </router-link>
                </template>
                <router-link
                  :to="{ name: 'insuranceDependent' }"
                  tag="li"
                  :class="
                    $route.path.includes('/insurancedependent')
                      ? activeClass
                      : ''
                  "
                  v-if="hasAccess('Insurance', 'My Insurance and Dependents')"
                >
                  <a>
                    <i class="la la-user-plus"></i>
                    <span v-if="role == 'admin'">
                      Employees' Insurance and<br />
                      Dependents
                    </span>
                    <span style="font-size: 14.5px" v-else>
                      My Insurance and Dependents
                    </span>
                  </a>
                </router-link>
                <!-- <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'insuranceReport' }"
                  tag="li"
                  :class="
                    $route.path.includes('/insurancereport') ? activeClass : ''
                  "
                >
                  <a><i class="la la-file-text"></i> <span>Reports</span></a>
                </router-link> -->
                <li 
                  class="submenu" 
                  v-if="enableEnhancedInsuranceDependentModule && role == 'admin'"
                >
                  <a>
                    <i class="la la-file-text"></i>
                    <span>Reports</span>
                    <span class="menu-arrow" style="top: 12px"></span>
                  </a>
                  <ul style="display: none">
                    <router-link
                      :to="{ name: 'insuranceReport' }"
                      tag="li"
                      :class="
                        $route.path.includes('/insurancereport') ? activeClass : ''
                      "
                    >
                      <a style="padding-left: 65px">
                        <i class="la la-file-text"></i>
                        <span style="word-spacing: -2px" class="ml-0">
                          Insurance & Benefit Report
                        </span>
                      </a>
                    </router-link>
                    <router-link
                      :to="{ name: 'lrsInsuranceRenewalReport' }"
                      tag="li"
                      :class="
                        $route.path.includes('/lrsinsurancerenewalreport') ? activeClass : ''
                      "
                    >
                      <a style="padding-left: 65px">
                        <i class="la la-file-text"></i>
                        <span style="word-spacing: -2px" class="ml-0">
                          LRS Insurance Renewal Report
                        </span>
                      </a>
                    </router-link>
                    <router-link
                      :to="{ name: 'lrmInsuranceRenewalReport' }"
                      tag="li"
                      :class="
                        $route.path.includes('/lrminsurancerenewalreport') ? activeClass : ''
                      "
                    >
                      <a style="padding-left: 65px">
                        <i class="la la-file-text"></i>
                        <span style="word-spacing: -2px" class="ml-0">
                          LRM Insurance Renewal Report
                        </span>
                      </a>
                    </router-link>
                  </ul>
                </li>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'insuranceChangesReport' }"
                  tag="li"
                  :class="
                    $route.path.includes('/insurancechangesreport')
                      ? activeClass
                      : ''
                  "
                >
                  <a><i class="la la-book"></i> <span>Changes Report</span></a>
                </router-link>
              </ul>
            </li>

            <li
              class="menu-title"
              v-if="enableAttendanceModule && hasAccess('Attendance', null) && !hasOnlyLamrAccess()"
            >
              <span>Attendance</span>
            </li>

            <!-- ATTENDANCE -->
            <li
              class="submenu"
              v-if="enableAttendanceModule && hasAccess('Attendance', null) && !hasOnlyLamrAccess()"
            >
              <a class="" v-if="hasAccess('Attendance', null)">
                <i class="la la-calendar"></i>
                <span>Attendance</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <router-link
                  :to="{ name: 'CADOImport' }"
                  tag="li"
                  :class="
                    $route.path.includes('/import/cado') ? activeClass : ''
                  "
                  v-if="role == 'admin'"
                >
                  <a>
                    <i class="fa fa-address-book"></i>
                    <span>Import List</span>
                  </a>
                </router-link>

                <router-link
                  :to="{ name: 'timesheet' }"
                  tag="li"
                  :class="
                    $route.path.includes('/attendance/timesheet')
                      ? activeClass
                      : ''
                  "
                  v-if="hasAccess('Attendance', 'My Timesheet')"
                >
                  <a>
                    <i class="fa fa-address-book"></i>
                    <span v-if="role != 'admin'">My Timesheet</span>
                    <span v-else>Timesheet</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    role == 'employee' &&
                    hasAccess('Attendance', 'My Monthly Overtime Report')
                  "
                  :to="{ name: 'myMonthlyOvertimeReport' }"
                  tag="li"
                  :class="
                    $route.path.includes(
                      '/attendance/report/timesheet/mymonthlyovertime'
                    )
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span>My Monthly Overtime Report</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    role == 'employee' &&
                    hasAccess(
                      'Attendance',
                      'My Monthly Overtime, Standby & Shift Allowance Report'
                    )
                  "
                  :to="{ name: 'myMonthlyOvertimeStandbyShiftAllowanceReport' }"
                  tag="li"
                  :class="
                    $route.path.includes(
                      '/attendance/report/timesheet/mymonthlyotstandbyshiftallowance'
                    )
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span>
                      My Monthly Overtime, Standby & Shift Allowance Report
                    </span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    (isManager() || role == 'admin') &&
                    hasAccess('Attendance', 'My Staff Timesheet List')
                  "
                  :to="{ name: 'timesheetList' }"
                  tag="li"
                  :class="
                    $route.path.includes('/attendance/list/timesheet') ||
                    $route.path.includes('/attendance/view/timesheet')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span v-if="role == 'admin'">Timesheet List</span>
                    <span v-else>My Staff Timesheet List</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    (role == 'admin' || isManager()) &&
                    hasAccess('Attendance', 'My Staff Monthly Overtime Report')
                  "
                  :to="{ name: 'monthlyOvertimeReport' }"
                  tag="li"
                  :class="
                    $route.path.includes(
                      '/attendance/report/timesheet/monthlyovertime'
                    )
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span v-if="isManager()">
                      My Staff Monthly Overtime Report
                    </span>
                    <span v-else>Monthly Overtime Report</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    (role == 'admin' || isManager()) &&
                    hasAccess(
                      'Attendance',
                      'My Staff Monthly Overtime, Standby & Shift Allowance Report'
                    )
                  "
                  :to="{ name: 'monthlyOvertimeStandbyShiftAllowanceReport' }"
                  tag="li"
                  :class="
                    $route.path.includes(
                      '/attendance/report/timesheet/monthlyotstandbyshiftallowance'
                    )
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span v-if="role == 'admin'">
                      Monthly Overtime, Standby & Shift Allowance Report
                    </span>
                    <span v-else-if="isManager()">
                      My Staff Monthly Overtime, Standby & Shift Allowance
                      Report
                    </span>
                  </a>
                </router-link>

                <router-link
                  :to="{ name: 'CADOLog' }"
                  tag="li"
                  :class="$route.path.includes('/log/cado') ? activeClass : ''"
                  v-if="role == 'admin'"
                >
                  <a><i class="fa fa-file-alt"></i> <span>Logs</span></a>
                </router-link>

                <router-link
                  :to="{ name: 'CADONotificationRecipient' }"
                  tag="li"
                  :class="
                    $route.path.includes('/notificationrecipient/cado')
                      ? activeClass
                      : ''
                  "
                  v-if="role == 'admin'"
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Import Notification Recipients</span>
                  </a>
                </router-link>

                <router-link
                  :to="{ name: 'applicableLeaveType' }"
                  tag="li"
                  :class="
                    $route.path.includes('/applicableleavetype')
                      ? activeClass
                      : ''
                  "
                  v-if="role == 'admin'"
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Applicable Leave Types</span>
                  </a>
                </router-link>
              </ul>
            </li>

            <li
              class="menu-title"
              v-if="
                enableCarParkModule &&
                (hasAccess('Car Park', null) || role == 'admin') &&
                !hasOnlyLamrAccess()
              "
            >
              <span>Car Park</span>
            </li>

            <!-- CARPARK -->
            <li
              class="submenu"
              v-if="
                enableCarParkModule &&
                (hasAccess('Car Park', null) || role == 'admin') &&
                !hasOnlyLamrAccess()
              "
            >
              <a class="" v-if="hasAccess('Car Park', null)">
                <i class="la la-car"></i>
                <span>Car Park</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <router-link
                  v-if="
                    role == 'employee' &&
                    hasAccess('Car Park', 'My Car Park Claim')
                  "
                  :to="{ name: 'myCarparkClaim' }"
                  tag="li"
                  :class="
                    $route.path.includes('carpark/myclaim') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="fa fa-money"></i>
                    <span>My Car Park Claim</span>
                  </a>
                </router-link>

                <router-link
                  :to="{ name: 'carparkClaimView' }"
                  tag="li"
                  :class="
                    $route.path.includes('carpark/viewclaims') ||
                    $route.path.includes('carpark/claimform')
                      ? activeClass
                      : ''
                  "
                  v-if="hasAccess('Car Park', 'View Car Park Claim')"
                >
                  <a>
                    <i class="fa fa-address-card"></i>
                    <span>View Car Park Claim</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    isManager() &&
                    hasAccess('Car Park', 'My Staff Car Park Claim')
                  "
                  :to="{ name: 'myStaffCarparkClaim' }"
                  tag="li"
                  :class="
                    $route.path.includes('carpark/mystaffcarparkclaim')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-address-card"></i>
                    <span>My Staff Car Park Claim</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    (isManager() || role == 'admin') &&
                    hasAccess(
                      'Car Park',
                      'My Staff Monthly Car Park Claim Report'
                    )
                  "
                  :to="{ name: 'monthlyCarparkClaimReport' }"
                  tag="li"
                  :class="
                    $route.path.includes('carpark/monthlyclaimreport')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>
                      {{ role == "admin" ? "" : "My Staff " }}Monthly Car Park
                      Claim Report
                    </span>
                  </a>
                </router-link>
              </ul>
            </li>

            <li
              class="menu-title"
              v-if="
                enableCorporatePassModule &&
                (!disableCorporatePassForEmployee ||
                  role == 'admin' ||
                  (disableCorporatePassForEmployee &&
                    allowedCorporatePassEmployee.indexOf(loginName) > -1)) &&
                (hasAccess('Corporate Pass', null) || role == 'admin') &&
                !hasOnlyLamrAccess()
              "
            >
              <span>Corporate Pass</span>
            </li>

            <!-- CORPORATE PASS -->
            <li
              class="submenu"
              v-if="
                enableCorporatePassModule &&
                (!disableCorporatePassForEmployee ||
                  role == 'admin' ||
                  (disableCorporatePassForEmployee &&
                    allowedCorporatePassEmployee.indexOf(loginName) > -1)) &&
                (hasAccess('Corporate Pass', null) || role == 'admin') && 
                !hasOnlyLamrAccess()
              "
            >
              <a class="" v-if="hasAccess('Corporate Pass', null)">
                <i class="la la-id-badge"></i>

                <span>Corporate Pass</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'manageCorporatePass' }"
                  tag="li"
                  :class="
                    $route.path.includes('corppass/manage') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="fas fa-image"></i>
                    <span>Manage Corporate Pass</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'managePassBlockingDate' }"
                  tag="li"
                  :class="
                    $route.path.includes('corppass/blockingdate')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-ban"></i>
                    <span>Manage Pass Blocking Date</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'managePassOption' }"
                  tag="li"
                  :class="
                    $route.path.includes('corppass/setting') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Manage Pass Options</span>
                  </a>
                </router-link>
                <router-link
                  :to="{ name: 'submitCorporatePass' }"
                  tag="li"
                  :class="
                    $route.path.includes('corppass/submit') ? activeClass : ''
                  "
                  v-if="hasAccess('Corporate Pass', 'Submit Corporate Pass')"
                >
                  <a>
                    <i class="fa fa-play"></i>
                    <span>Submit Corporate Pass</span>
                  </a>
                </router-link>
                <router-link
                  :to="{ name: 'managePassBookingHistory' }"
                  tag="li"
                  :class="
                    $route.path.includes('corppass/booking') ? activeClass : ''
                  "
                  v-if="hasAccess('Corporate Pass', 'My Booking History')"
                >
                  <a>
                    <i class="fas fa-book"></i>
                    <span v-if="role == 'admin'">
                      Manage Pass Booking History</span
                    >
                    <span v-else>My Booking History</span>
                  </a>
                </router-link>
              </ul>
            </li>

            <!-- LEAVE ABSENCE -->
            <li
              class="menu-title"
              v-if="
                enableLeaveAbsenceModule && hasAccess('Leave of Absence', null)
              "
            >
              <span>Leave of Absence</span>
            </li>
            <li
              class="submenu"
              v-if="
                enableLeaveAbsenceModule && hasAccess('Leave of Absence', null)
              "
            >
              <a class="" v-if="hasAccess('Leave of Absence', null)">
                <i class="la la-user-clock"></i>
                <span>Leave of Absence</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'leaveReasonCorporate' }"
                  tag="li"
                  :class="
                    $route.path.includes('leave/leavereasoncorporate') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Leave Reason (Corporate)</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'calculationType' }"
                  tag="li"
                  :class="
                    $route.path.includes('leave/calculationtype') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Calculation Type</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'manageLeaveName' }"
                  tag="li"
                  :class="
                    $route.path.includes('leave/manage') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Manage Leave Name</span>
                  </a>
                </router-link>    
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'viewLeave' }"
                  tag="li"
                  :class="$route.path == '/leave/view' ? activeClass : ''"
                >
                  <a>
                    <i class="far fa-calendar-alt"></i>
                    <span>View Leave of Absence</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    role == 'employee' &&
                    hasAccess('Leave of Absence', 'My Leave of Absence')
                  "
                  :to="{ name: 'myLeave' }"
                  tag="li"
                  :class="$route.path == '/leave/myleave' ? activeClass : ''"
                >
                  <a>
                    <i class="far fa-calendar"></i>
                    <span>My Leave of Absence</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    isManager() &&
                    hasAccess('Leave of Absence', 'My Staff Leave of Absence')
                  "
                  :to="{ name: 'myStaffLeave' }"
                  tag="li"
                  :class="
                    $route.path == '/leave/mystaffleave' ? activeClass : ''
                  "
                >
                  <a>
                    <i class="far fa-calendar"></i>
                    <span>My Staff Leave of Absence</span>
                  </a>
                </router-link>
                
                <li 
                  class="submenu" 
                  v-if="enableLoaCollectionModule && role == 'admin'"
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>LOA Reports</span>
                    <span class="menu-arrow" style="top: 12px"></span>
                  </a>
                  <ul style="display: none">
                    <router-link
                      :to="{ name: 'viewLeaveReport' }"
                      tag="li"
                      :class="
                        $route.path.includes('leave/viewreport') ? activeClass : ''
                      "
                    >
                      <a style="padding-left: 65px">
                        <i class="la la-file-text"></i>
                        <span style="word-spacing: -2px" class="ml-0">
                          LOA IGNITE Application Report
                        </span>
                      </a>
                    </router-link>
                    <router-link
                      :to="{ name: 'loaCollectionReport' }"
                      tag="li"
                      :class="
                        $route.path.includes('leave/loacollectionreport') ? activeClass : ''
                      "
                    >
                      <a style="padding-left: 65px">
                        <i class="la la-file-text"></i>
                        <span style="word-spacing: -2px" class="ml-0">
                          LOA Collection Report
                        </span>
                      </a>
                    </router-link>
                  </ul>
                </li>

                <li 
                  class="submenu" 
                  v-if="enableLoaCollectionModule && role !== 'admin'"
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>LOA Reports</span>
                    <span class="menu-arrow" style="top: 12px"></span>
                  </a>
                  <ul style="display: none">
                    <router-link
                      v-if="
                        role == 'employee' &&
                        hasAccess('Leave of Absence', 'My LOA IGNITE Application Report')
                      "
                      :to="{ name: 'myLeaveReport' }"
                      tag="li"
                      :class="
                        $route.path.includes('leave/myleavereport')
                          ? activeClass
                          : ''
                      "
                    >
                      <a>
                        <i class="la la-file-text"></i>
                        <span style="word-spacing: -2px" class="ml-0">
                          My LOA IGNITE Application Report
                        </span>
                      </a>
                    </router-link>
                    <router-link
                      v-if="
                        isManager() &&
                        hasAccess(
                          'Leave of Absence',
                          'My Staff LOA IGNITE Application Report'
                        )
                      "
                      :to="{ name: 'myStaffLeaveReport' }"
                      tag="li"
                      :class="
                        $route.path.includes('leave/mystaffleavereport')
                          ? activeClass
                          : ''
                      "
                    >
                      <a>
                        <i class="la la-file-text"></i>
                        <span style="word-spacing: -2px" class="ml-0">
                          My Staff LOA IGNITE Application Report
                        </span>
                      </a>
                    </router-link>
                  </ul>
                </li>
              </ul>
            </li>
            <!-- /LEAVE ABSENCE -->

            <!-- FWA -->
            <li
              class="menu-title"
              v-if="enableFwaModule && hasAccess('FWA', null) && !hasOnlyLamrAccess()"
            >
              <span>Flexible Work Arrangement</span>
            </li>
            <li
              class="submenu"
              v-if="enableFwaModule && hasAccess('FWA', null) && !hasOnlyLamrAccess()"
            >
              <a class="" v-if="hasAccess('FWA', null)">
                <i class="la la-calendar-check"></i>
                <span style="word-spacing: -2px">
                  Flexible Work Arrangement
                </span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <router-link
                  v-if="role == 'employee' && hasAccess('FWA', 'My FWA')"
                  :to="{ name: 'fwaForm' }"
                  tag="li"
                  :class="$route.path.includes('fwa/form') ? activeClass : ''"
                >
                  <a>
                    <i class="fas fa-street-view"></i>
                    <span>My FWA</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'employee' && hasAccess('FWA', 'My FWA Record')"
                  :to="{ name: 'fwaMyRecord' }"
                  tag="li"
                  :class="
                    $route.path.includes('fwa/my-fwa-record') ||
                    ($route.path.includes('fwa/view') &&
                      $store.state.fwaSourcePage == 'My FWA Record')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span>My FWA Record</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    (isManager() || isNextManager()) &&
                    hasAccess('FWA', 'My Staff FWA Record')
                  "
                  :to="{ name: 'fwaMyStaffRecord' }"
                  tag="li"
                  :class="
                    $route.path.includes('fwa/my-staff-fwa-record') ||
                    ($route.path.includes('fwa/view') &&
                      $store.state.fwaSourcePage == 'My Staff FWA Record')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span>My Staff FWA Record</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    (isManager() || isNextManager()) &&
                    hasAccess('FWA', 'My Staff FWA Report')
                  "
                  :to="{ name: 'fwaReport' }"
                  tag="li"
                  :class="$route.path.includes('fwa/report') ? activeClass : ''"
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>My Staff FWA Report</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'fwaApprover' }"
                  tag="li"
                  :class="
                    $route.path.includes('fwa/approver') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Manage LRT 2nd Level Approver</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'fwaSetup' }"
                  tag="li"
                  :class="$route.path.includes('fwa/setup') ? activeClass : ''"
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Manage FWA Setup</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'fwaManageRecord' }"
                  tag="li"
                  :class="
                    $route.path.includes('fwa/manage-fwa-record') ||
                    ($route.path.includes('fwa/view') &&
                      $store.state.fwaSourcePage == 'Manage FWA Record')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-list-alt"></i>
                    <span>Manage FWA Record</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'fwaReport' }"
                  tag="li"
                  :class="$route.path.includes('fwa/report') ? activeClass : ''"
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>FWA Report</span>
                  </a>
                </router-link>
              </ul>
            </li>
            <!-- /FWA -->

            <!-- LEAVE UTILIZATION REPORT -->
            <li
              class="menu-title"
              v-if="
                enableLeaveUtilizationReportModule &&
                hasAccess('Leave Utilization Report', null) && 
                !hasOnlyLamrAccess()
              "
            >
              <span>Leave Utilization Report</span>
            </li>
            <li
              class="submenu"
              v-if="
                enableLeaveUtilizationReportModule &&
                hasAccess('Leave Utilization Report', null) &&
                !hasOnlyLamrAccess()
              "
            >
              <a class="" v-if="hasAccess('Leave Utilization Report', null)">
                <i class="la la-user-clock"></i>
                <span>Leave Utilization Report</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'adminLeaveUtilizationReport' }"
                  tag="li"
                  :class="
                    $route.path.includes('leave-utilization-report/admin')
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>Leave Utilization Report</span>
                  </a>
                </router-link>
                <router-link
                  v-if="role == 'admin'"
                  :to="{ name: 'manageShutdownCarryForward' }"
                  tag="li"
                  :class="
                    $route.path ==
                    '/leave-utilization-report/manage-shutdown-carry-forward'
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-cog"></i>
                    <span>Manage Shutdown Days and Allowed Carry Forward</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    role == 'employee' &&
                    hasAccess(
                      'Leave Utilization Report',
                      'My Leave Utilization Report'
                    )
                  "
                  :to="{ name: 'myLeaveUtilizationReport' }"
                  tag="li"
                  :class="
                    $route.path == '/leave-utilization-report/my-report'
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>My Leave Utilization Report</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    isManager() &&
                    hasAccess(
                      'Leave Utilization Report',
                      'My Staff Leave Utilization Report'
                    )
                  "
                  :to="{ name: 'myStaffLeaveUtilizationReport' }"
                  tag="li"
                  :class="
                    $route.path == '/leave-utilization-report/my-staff-report'
                      ? activeClass
                      : ''
                  "
                >
                  <a>
                    <i class="fa fa-file-text-o"></i>
                    <span>My Staff Leave Utilization Report</span>
                  </a>
                </router-link>
              </ul>
            </li>
            <!-- /LEAVE UTILIZATION REPORT -->

            <!-- OIL AND OT REPORT -->
            <template
              v-if="enableLeaveUtilizationReportModule && role == 'admin' && !hasOnlyLamrAccess()"
            >
              <li class="menu-title">
                <span>OIL and OT Report</span>
              </li>
              <router-link
                :to="{ name: 'oilAndOtReport' }"
                tag="li"
                :class="
                  $route.path.includes('/oilandotreport') ? activeClass : ''
                "
              >
                <a>
                  <i class="la la-file-text"></i>
                  <span>OIL and OT Report</span>
                </a>
              </router-link>
            </template>
            <!-- /OIL AND OT REPORT -->

            <div class="py-2"></div>

            <!-- SYSTEM -->
            <template
              v-if="
                (role == 'admin' && !hasOnlyLamrAccess()) ||
                (isManager() &&
                  enableDelegationModule &&
                  hasAccess('System', null))
              "
            >
              <li class="menu-title" v-if="hasAccess('System', null)">
                <span>System</span>
              </li>

              <!-- <router-link
                v-if="enableAttendanceModule && role == 'admin'"
                :to="{ name: 'settings' }"
                tag="li"
                :class="$route.path.includes('/settings') ? activeClass : ''"
              >
                <a><i class="la la-cogs"></i> <span>Settings</span></a>
              </router-link> -->

              <router-link
                v-if="enableInsuranceModule && role == 'admin'"
                :to="{ name: 'option' }"
                tag="li"
                :class="$route.path.includes('/option') ? activeClass : ''"
              >
                <a><i class="la la-cogs"></i> <span>Options</span></a>
              </router-link>

              <router-link
                v-if="
                  enableDelegationModule && hasAccess('System', 'Delegation')
                "
                :to="{ name: 'delegationList' }"
                tag="li"
                :class="$route.path.includes('/delegation') ? activeClass : ''"
              >
                <a><i class="la la-cogs"></i> <span>Delegation</span></a>
              </router-link>

              <router-link
                v-if="enableAttendanceModule && role == 'admin'"
                :to="{ name: 'overtimepaymentcalculation' }"
                tag="li"
                :class="
                  $route.path.includes('/overtimepaymentcalculation')
                    ? activeClass
                    : ''
                "
              >
                <a>
                  <i class="la la-cogs"></i>
                  <span>Overtime Payment Calculations</span>
                </a>
              </router-link>

              <router-link
                v-if="enableCorporatePassModule && role == 'admin'"
                :to="{ name: 'publicHoliday' }"
                tag="li"
                :class="
                  $route.path.includes('/publicholiday') ? activeClass : ''
                "
              >
                <a><i class="la la-cogs"></i> <span>Attendance Holiday</span></a>
              </router-link>

              <router-link
                v-if="enableSwingShiftModule && role == 'admin'"
                :to="{ name: 'leaveHoliday' }"
                tag="li"
                :class="
                  $route.path.includes('/leaveholiday') ? activeClass : ''
                "
              >
                <a><i class="la la-cogs"></i> <span>Leave Holidays</span></a>
              </router-link>

              <router-link
                v-if="enableEmailLogModule && role == 'admin'"
                :to="{ name: 'emailLog' }"
                tag="li"
                :class="$route.path.includes('/emaillog') ? activeClass : ''"
              >
                <a><i class="la la-cogs"></i> <span>Email Logs</span></a>
              </router-link>

              <router-link
                v-if="enableSyncLogModule && role == 'admin'"
                :to="{ name: 'syncLog' }"
                tag="li"
                :class="$route.path.includes('/synclog') ? activeClass : ''"
              >
                <a><i class="la la-cogs"></i> <span>Sync Logs</span></a>
              </router-link>

              <router-link
                v-if="enableReminderModule && role == 'admin'"
                :to="{ name: 'reminderList' }"
                tag="li"
                :class="$route.path.includes('/reminder') ? activeClass : ''"
              >
                <a><i class="la la-cogs"></i> <span>Reminder</span></a>
              </router-link>

              <router-link
                v-if="enableWorkCalendarModule && role == 'admin'"
                :to="{ name: 'workCalendar' }"
                tag="li"
                :class="
                  $route.path.includes('/workcalendar') ? activeClass : ''
                "
              >
                <a><i class="la la-cogs"></i> <span>Work Calendar</span></a>
              </router-link>

              <router-link
                v-if="enableSwingShiftModule && role == 'admin'"
                :to="{ name: 'shiftCode' }"
                tag="li"
                :class="
                  $route.path.includes('/shiftcode') ? activeClass : ''
                "
              >
                <a><i class="la la-cogs"></i> <span>Shift Code</span></a>
              </router-link>

              <router-link
                v-if="enableLocationModule && role == 'admin'"
                :to="{ name: 'location' }"
                tag="li"
                :class="
                  $route.path.includes('/location') ? activeClass : ''
                "
              >
                <a><i class="la la-cogs"></i> <span>Location</span></a>
              </router-link>

              <router-link
                v-if="enableMenuModule && role == 'admin'"
                :to="{ name: 'menu' }"
                tag="li"
                :class="$route.path.includes('/menu') ? activeClass : ''"
              >
                <a><i class="la la-cogs"></i> <span>Menu</span></a>
              </router-link>
            </template>
            <!-- /SYSTEM -->
          </ul>
        </div>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import API from "../../http-common.js";
import config from "../../config.js";
//import $ from "jquery";
export default {
  components: {
    vueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        suppressScrollX: false,
      },
      menus: [],
      activeClass: "active",
      enableInsuranceModule: config.ENABLE_INSURANCE_MODULE,
      enableAttendanceModule: config.ENABLE_ATTENDANCE_MODULE,
      enableCarParkModule: config.ENABLE_CAR_PARK_MODULE,
      enableCorporatePassModule: config.ENABLE_CORPORATE_PASS_MODULE,
      enableDelegationModule: config.ENABLE_DELEGATION_MODULE,
      disableCorporatePassForEmployee:
        config.DISABLE_COPORATE_PASS_FOR_EMPLOYEE,
      allowedCorporatePassEmployee: config.ALLOWED_CORPORATE_PASS_EMPLOYEE,
      enableLeaveAbsenceModule: config.ENABLE_LEAVE_ABSENCE_MODULE,
      enableEmailLogModule: config.ENABLE_EMAIL_LOG_MODULE,
      enableSyncLogModule: config.ENABLE_SYNC_LOG_MODULE,
      enableReminderModule: config.ENABLE_REMINDER_MODULE,
      enableWorkCalendarModule: config.ENABLE_WORK_CALENDAR_MODULE,
      enableMenuModule: config.ENABLE_MENU_MODULE,
      enableFwaModule: config.ENABLE_FWA_MODULE,
      enableLeaveUtilizationReportModule:
        config.ENABLE_LEAVE_UTILIZATION_REPORT_MODULE,
      enableSwingShiftModule: config.ENABLE_SWING_SHIFT_MODULE,
      enableLoaCollectionModule: config.ENABLE_LOA_COLLECTION_MODULE,
      enableEnhancedInsuranceDependentModule: config.ENABLE_ENHANCED_INSURANCE_DEPENDENT_MODULE,
      enableLocationModule: config.ENABLE_LOCATION_MODULE
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    branch() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Branch;
    },
    loginName() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.LoginName;
    },
  },
  methods: {
    scrollHanle(evt) {
      // console.log(evt);
    },
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    isNextManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsNextManager ? data.IsNextManager : false;
    },
    hasManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.HasManager ? data.HasManager : false;
    },
    hasCarparkClaimDelegation() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.HasCarparkClaimDelegation
        ? data.HasCarparkClaimDelegation
        : false;
    },
    hasTimesheetDelegation() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.HasTimesheetDelegation ? data.HasTimesheetDelegation : false;
    },
    hasOnlyLamrAccess(){
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.HasOnlyLamrAccess ? data.HasOnlyLamrAccess : false;
    },
    getMenus() {
      let param = {
        Token: this.tokenObj.Token,
        Company: this.tokenObj.Company,
      };
      this.$store.state.isLoading = true;
      API.getMenus(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.menus = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    hasAccess(parentMenu, childMenu) {
      if (this.role == "admin") return true;
      let hasAccess = false;
      let parent = this.menus.find((c) => c.Parent == parentMenu);
      if (parent) {
        if (childMenu) {
          let selectedChild = parent.Children.find(
            (c) => c.Name == childMenu && c.Selected == true
          );
          if (selectedChild) hasAccess = true;
        } else {
          let selectedChildren = parent.Children.filter(
            (c) => c.Selected == true
          );
          hasAccess = selectedChildren && selectedChildren.length;
        }
      }
      return hasAccess;
    },
  },
  created() {
    if (this.role != "admin") this.getMenus();
  },
  mounted() {
    $(document).on("click", "#sidebar-menu a", function (e) {
      if ($(this).parent().hasClass("submenu")) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this).next("ul").slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this).next("ul").slideUp(350);
      }
    });

    //expand any active link on initial load
    window.setTimeout(() => {
      $("#sidebar-menu ul li.active a")
        .parents("li:last")
        .children("a:first")
        .addClass("active")
        .trigger("click");
    }, 500);
  },
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
.sidebar {
  width: 280px;
  word-spacing: -3px;
}

.slide-nav .sidebar {
  margin-left: 0;
}

@media only screen and (min-width: 991px) {
  .mini-sidebar .sidebar {
    width: 60px;
  }
  .mini-sidebar.expand-menu .sidebar {
    width: 270px;
  }
}

@media only screen and (max-width: 991.98px) {
  .sidebar {
    margin-left: -270px;
    width: 270px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Layout/Sidebar.vue